export default __webpack_public_path__ + "static/media/bg-sm-2x.abcb86cf.png";